module.exports = __webpack_public_path__ + "img/Marquise a plat.bebafdc3.jpg";